<template>
  <div class="">
    <div class="vip_buy">
      <div class="header">
        <div class="left">
          <img :src="user.avatar != ''
            ? user.avatar
            : require('../../assets/images/home/home15.png')
            " alt="" class="avater" />
          <div class="user_info">
            <div class="top">
              {{ user.nickname }}，您当前还不是会员
              <img src="" alt="" />
            </div>
            <!-- <div class="bottom">到期时间：2025.04.02</div> -->
          </div>
        </div>
        <img src="../../assets/images/vip/vip23.png" alt="" class="right" @click="close(1)" style="cursor: pointer" />
      </div>
      <div class="vip_package">
        <div class="vip_pack_chi" :class="vipPackIndex == index ? 'vip_pack_sele' : ''" v-for="(item, index) in vipList"
          @click="vipSele(item, index)" style="cursor: pointer">
          <div>
            {{ item.name }}<span v-if="item.subscript != ''">{{ item.subscript }}</span>
          </div>
          <div>
            ¥<span style="font-size: 40px">{{ item.price }}</span>
          </div>
          <!-- <div v-show="item.num != -1">平均每月¥{{ computedNum(item, index) }}</div> -->
          <div>{{ item.description }}</div>
        </div>
      </div>
      <div class="qr_code_box">
        <div class="qr_code">
          <vue-qr class="vue_qr" v-if="isWechat == true" :text="enPayInfo" :size="209" :margin="4"
            :logo-src="require('../../assets/images/vip/vip24.png')"></vue-qr>
          <iframe id="dialogIframe" v-if="!isWechat == true" class="dialogIframe" :srcdoc="alipayFormHtml.pay_info"
            frameborder="0" style="border: none"></iframe>
        </div>
        <div class="right">
          <div class="r_tip">选择你的支付方式</div>
          <div>
            <div :class="isWechat ? 'sele' : ''" @click="paySele(1)" style="cursor: pointer">
              <img src="../../assets/images/vip/vip24.png" :style="!isWechat ? 'opacity: 0.5;' : ''" alt="" />
              微信支付
            </div>
            <div :class="!isWechat ? 'sele' : ''" @click="paySele(2)" style="cursor: pointer">
              <img src="../../assets/images/vip/vip25.png" :style="isWechat ? 'opacity: 0.5;' : ''" alt="" />
              支付宝支付
            </div>
          </div>
          <div v-if="vipList">
            应付金额
            <span style="color: #fc4513">¥{{ vipList[vipPackIndex].price }}</span>
          </div>
          <div>
            剩余支付时间 <span style="color: #fc4513">{{ formatSeconds(payTime) }}</span>，否则订单将自动失效
          </div>
        </div>
      </div>
      <div class="agreement">
        开通请前阅读并同意
        <a href="https://h5.xlhcq.com/wankang/member.html" style="color: #10a47f" target="_blank">《会员服务协议》</a>
        、
        <a href="https://h5.xlhcq.com/wankang/payAgreement.html" style="color: #10a47f"
          target="_blank">《万康人体解剖支付协议》</a>。
      </div>
      <div class="bth_buy" @click="close(2)" style="cursor: pointer">我已完成支付</div>
    </div>
  </div>
</template>

<script>
import aes from "@/utils/AES";
import Api from "@/api/api";
import vueQr from "vue-qr";
export default {
  data() {
    return {
      user: {},
      vipList: null,
      vipPackIndex: 0, // 选中的vip
      packSeleData: {}, // 选中的包的数据
      isWechat: false, // 默认微信支付
      timer: null,
      timer2: null,
      enPayInfo: "null",
      payTime: 900, // 支付倒计时
      alipayFormHtml: {},
    };
  },

  mounted() {
    if (localStorage.getItem("token")) {
      Api.getUserInfo().then((res) => {
        console.log("拿到的用户信息", res);
        if (res.code == 200) {
          this.user = res.data;
        }
      });
    }
    this.getVipList();
    // 如果是单独切换的倒是好做，但是现在是两个
    this.payTime = 900;
    this.timer2 = setInterval(() => {
      this.payTime = this.payTime - 1;
    }, 1000);
    // 启动倒计时
    setTimeout(() => {
      clearInterval(this.timer2);
      this.timer2 = null;
      sessionStorage.removeItem("payData");
      sessionStorage.removeItem("payData_form");
    }, 900000);
  },

  components: {
    vueQr,
  },
  methods: {
    close(z) {
      this.$emit("close", z);
    },
    // 获取 vip 列表
    getVipList() {
      Api.getVipList().then((res) => {
        console.log("返回的vip列表", res.data);
        if (res.code == 200) {
          this.$td.track("wb_vip_main_im", {
            origin: aes.dedata(sessionStorage.getItem("origin")),
            sale: "",
          });
          this.$td.track("wb_vip_pay_ck", {
            price: res.data[0].price,
            origin: aes.dedata(sessionStorage.getItem("origin")),
            sale: res.data[0].strategy,
          });
          console.log("拿到的包", res.data);
          for (let i in res.data) {
            if (res.data[i].is_preferred == 1) {
              this.vipPackIndex = i;
            }
          }
          this.vipList = res.data;
          this.payWaySele(2, res.data[0]); // 默认1微信  2支付宝
        } else {
        }
      });
    },
    computedNum(z, x) {
      return (((z.price - 0) / z.num) * 31).toFixed(2);
    },
    vipSele(z, x) {
      console.log("选择的包", z, x);
      this.vipPackIndex = x;
      sessionStorage.removeItem("payData");
      sessionStorage.removeItem("payData_form");
      this.isWechat = true;
      clearInterval(this.timer2);
      this.timer2 = null;
      this.payWaySele(1, this.vipList[x]);
      // 如果是单独切换的倒是好做，但是现在是两个
      this.payTime = 900;
      this.timer2 = setInterval(() => {
        this.payTime = this.payTime - 1;
      }, 1000);
      this.$td.track("wb_vip_pay_ck", {
        price: z.price,
        origin: aes.dedata(sessionStorage.getItem("origin")),
        sale: z.strategy,
      });
      // 启动倒计时
      setTimeout(() => {
        clearInterval(this.timer2);
        this.timer2 = null;
        sessionStorage.removeItem("payData");
        sessionStorage.removeItem("payData_form");
      }, 900000);
    },
    paySele(z) {
      if (z == 1) {
        this.isWechat = true;
        this.payWaySele(z, this.vipList[this.vipPackIndex]);
      } else {
        this.isWechat = false;
        this.payWaySele(z, this.vipList[this.vipPackIndex]);
      }
    },
    // 支付方式点击 1、微信 2、支付宝
    payWaySele(z, x) {
      this.clearTimer();
      if (z == 1) {
        this.payWay = 1;
        // 微信支付
        // 点击之后还要设置计时器避免重复调用
        let data = {
          vip_id: x.id,
          pay_type: 6,
          source: aes.dedata(sessionStorage.getItem("origin")),
        };
        if (sessionStorage.getItem("payData")) {
          let payData = JSON.parse(aes.dedata(sessionStorage.getItem("payData")));
          console.log("解出来的参数", payData);
          this.dialogQrCode = true;
          this.enPayInfo = payData.code_url;
          this.payData = payData;
          this.timer = setInterval(() => {
            let data2 = {
              order_no: this.payData.order_no,
            };
            Api.getPayResult(data2).then((res) => {
              console.log("支付结果请求", res);
              if (res.code == 200) {
                // 支付成功
                if (res.data?.status != 0) {
                  sessionStorage.removeItem("payData");
                  this.$td.track("wb_vip_pay_suc", {
                    price: x.price,
                    origin: aes.dedata(sessionStorage.getItem("origin")),
                    sale: x.strategy,
                  });
                  setTimeout(() => {
                    this.clearTimer();
                    clearInterval(this.timer2);
                    this.timer2 = null;
                    this.close(3);
                  });
                }
              }
            });
          }, 2000);
        } else {
          Api.getVipCode(data).then((res) => {
            console.log("获取的会员信息22", res.data);
            if (res.code == 200) {
              this.dialogQrCode = true;
              this.enPayInfo = res.data.code_url;
              this.payData = res.data;
              sessionStorage.setItem("payData", aes.endata(JSON.stringify(res.data)));
              setTimeout(() => {
                // 15分钟时重新请求
                sessionStorage.removeItem("payData");
              }, 900000);
              this.timer = setInterval(() => {
                let data2 = {
                  order_no: this.payData.order_no,
                };
                Api.getPayResult(data2).then((res) => {
                  console.log("支付结果", res.data);
                  if (res.code == 200) {
                    // 支付成功
                    if (!res.data) return
                    if (res.data.status != 0) {
                      sessionStorage.removeItem("payData");
                      this.$td.track("wb_vip_pay_suc", {
                        price: x.price,
                        origin: aes.dedata(sessionStorage.getItem("origin")),
                        sale: x.strategy,
                      });
                      setTimeout(() => {
                        this.clearTimer();
                        clearInterval(this.timer2);
                        this.timer2 = null;
                        this.close(3);
                      });
                    }
                  }
                });
              }, 2000);
            } else {
            }
          });
        }
      } else if (z == 2) {
        this.payWay = 2;
        let data = {
          vip_id: x.id,
          pay_type: 7,
        };
        if (sessionStorage.getItem("payData_form")) {
          let payData = JSON.parse(aes.dedata(sessionStorage.getItem("payData_form")));
          console.log("支付宝解出来", payData);
          this.dialogIframe = true;
          this.alipayFormHtml = payData;
          this.timer = setInterval(() => {
            let data2 = {
              order_no: this.alipayFormHtml.order_no,
            };
            Api.getPayResult(data2).then((res) => {
              console.log("支付结果请求", res);
              if (res.code == 200) {
                // 支付成功
                if (res.data.status != 0) {
                  sessionStorage.removeItem("payData");
                  this.$td.track("wb_vip_pay_suc", {
                    price: x.price,
                    origin: aes.dedata(sessionStorage.getItem("origin")),
                    sale: x.strategy,
                  });
                  this.clearTimer();
                  clearInterval(this.timer2);
                  this.timer2 = null;
                  this.close(3);
                }
              }
            });
          }, 2000);
        } else {
          Api.getVipCode(data).then((res) => {
            if (res.code == 200) {
              console.log("支付宝支付数据", res.data);
              this.dialogIframe = true;
              this.alipayFormHtml = res.data;
              sessionStorage.setItem(
                "payData_form",
                aes.endata(JSON.stringify(res.data))
              );
              setTimeout(() => {
                // 15分钟时重新请求
                sessionStorage.removeItem("payData_form");
              }, 900000);
              this.timer = setInterval(() => {
                let data2 = {
                  order_no: this.alipayFormHtml.order_no,
                };
                Api.getPayResult(data2).then((res) => {
                  console.log("支付结果请求", res.data, x);
                  if (res.code == 200) {
                    // 支付成功
                    if (res.data.status != 0) {
                      sessionStorage.removeItem("payData_form");
                      this.$td.track("wb_vip_pay_suc", {
                        price: x.price,
                        origin: aes.dedata(sessionStorage.getItem("origin")),
                        sale: x.strategy,
                      });
                      // 支付成功
                      this.clearTimer();
                      clearInterval(this.timer2);
                      this.timer2 = null;
                      this.close(3);
                    }
                  }
                });
              }, 2000);
            } else {
            }
          });
        }
      }
    },
    formatSeconds(seconds) {
      let minutes = Math.floor(seconds / 60);
      let remainingSeconds = seconds % 60; 
      minutes = minutes < 10 ? "0" + minutes : minutes;
      remainingSeconds =
        remainingSeconds < 10 ? "0" + remainingSeconds : remainingSeconds;

      return minutes + "分" + remainingSeconds + "秒";
    },
    // 清除计时器
    clearTimer() {
      clearInterval(this.timer);
      this.timer = null;
      clearInterval(this.timer2);
      this.timer2 = null;
    },
  },
  beforeDestroy() {
    console.log("销毁");
    this.clearTimer();
    sessionStorage.removeItem("payData");
    sessionStorage.removeItem("payData_form");
    return;
  },
};
</script>

<style scoped lang="scss">
.vip_buy {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 938px;
  height: 705px;
  background: #f5f6fa;
  border-radius: 12px;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 938px;
    height: 68px;
    background: linear-gradient(315deg, #262932 0%, #706c6f 100%);
    border-radius: 12px 12px 0px 0px;

    .left {
      height: 36px;
      display: flex;
      margin-left: 16px;

      .avater {
        width: 36px;
        height: 36px;
        margin-right: 8px;
      }

      .user_info {
        display: flex;
        align-items: center;

        .top {
          font-weight: 500;
          font-size: 14px;
          color: #ffffff;
          line-height: 21px;
          text-align: left;
          font-style: normal;
        }

        .bottom {
          font-family: SourceHanSansCN, SourceHanSansCN;
          font-weight: 400;
          font-size: 12px;
          color: #ffffff;
          line-height: 18px;
          text-align: left;
          font-style: normal;
        }
      }
    }

    .right {
      width: 20px;
      height: 20px;
      margin-right: 16px;
    }
  }

  .vip_package {
    display: flex;
    align-items: center;
    width: 778px;
    margin-top: 20px;
    margin-bottom: 20px;

    // border: 1px solid transparent;
    // background-image: linear-gradient(#1D1D1D,#1D1D1D),
    //     linear-gradient(to right,
    //     rgba(31, 61, 255, 1),
    //     rgba(255, 47, 76, 1));
    // background-origin: border-box;
    // background-clip: content-box, border-box;
    // border-radius: 5px;
    >.vip_pack_chi {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 242px;
      height: 205px;
      background: #ffffff;
      box-shadow: 0px 4px 24px 0px rgba(28, 31, 35, 0.04);
      border-radius: 8px;
      border: 2px solid transparent;
      margin-right: 20px;

      >div:nth-child(1) {
        position: relative;
        font-family: SourceHanSansSC, SourceHanSansSC;
        font-weight: 400;
        font-size: 24px;
        color: #000000;
        text-align: left;
        font-style: normal;

        span {
          position: absolute;
          right: -50px;
          top: -25px;
          padding: 6px 8px;
          background: #fc4513;
          border-radius: 8px;
          font-family: SourceHanSansSC, SourceHanSansSC;
          font-weight: 400;
          font-size: 13px;
          color: #ffffff;
          text-align: center;
          font-style: normal;
        }
      }

      div:nth-child(2) {
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: bold;
        font-size: 20px;
        color: #000000;
        line-height: 30px;
        text-align: left;
        font-style: normal;
        margin-top: 24px;
        margin-bottom: 22px;
      }

      div:last-child {
        font-family: SourceHanSansSC, SourceHanSansSC;
        font-weight: 400;
        font-size: 13px;
        color: #000000;
        line-height: 19px;
        text-align: left;
        font-style: normal;
      }
    }

    .vip_pack_sele {
      background-image: linear-gradient(#ffffff, #ffffff),
        linear-gradient(to right, #29be92, #29be92);
      background-origin: border-box;
      background-clip: content-box, border-box;
    }

    >div:last-child {
      margin-right: 0;
    }
  }

  .qr_code_box {
    display: flex;
    align-items: center;
    width: 778px;
    padding: 20px 0;
    background: #ffffff;
    border-radius: 8px;
    margin-bottom: 18px;

    .qr_code {
      display: flex;
      justify-content: center;
      align-items: center;
      //   width: 158px;
      //   height: 158px;
      width: 209px;
      height: 209px;
      background: #ffffff;
      border-radius: 5px;
      border: 1px solid rgba(0, 0, 0, 0.15);
      margin-right: 26px;
      margin-left: 30px;

      .dialogIframe::-webkit-scrollbar {
        display: none;
      }

      .dialogIframe {
        width: 204px;
        height: 204px;
      }
    }

    .right {
      .r_tip {
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 500;
        font-size: 16px;
        color: #262932;
        line-height: 24px;
        text-align: left;
        font-style: normal;
      }

      >div:nth-child(2) {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 14px 0 26px 0;
        width: 270px;
        height: 48px;
        background: #ffffff;
        border-radius: 8px;
        border: 1px solid #f0f1f5;

        >div {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 124px;
          height: 44px;
          background-color: transparent;
          border-radius: 6px;
          font-family: SourceHanSansCN, SourceHanSansCN;
          font-weight: 400;
          font-size: 14px;
          color: #81848b;
          line-height: 21px;
          text-align: left;
          font-style: normal;

          img {
            width: 32px;
            height: 32px;
            margin-right: 8px;
          }
        }

        .sele {
          color: #10a47f;
          background-color: #d0ede5;
        }
      }

      >div:nth-child(3) {
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 500;
        font-size: 16px;
        color: #262932;
        line-height: 24px;
        text-align: left;
        font-style: normal;
        margin: 0 0 12px 0;
      }

      >div:nth-child(4) {
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 400;
        font-size: 14px;
        color: #3f424d;
        line-height: 21px;
        text-align: left;
        font-style: normal;
      }
    }
  }

  .agreement {
    width: 778px;
    height: 12px;
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 400;
    font-size: 12px;
    color: #3f424d;
    line-height: 18px;
    text-align: left;
    font-style: normal;
    margin-bottom: 32px;

    a {
      text-decoration: none;
    }
  }

  .bth_buy {
    width: 490px;
    height: 40px;
    background: #f5f6fa;
    border-radius: 8px;
    border: 1px solid #c0c1c5;
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 400;
    font-size: 16px;
    color: #262932;
    line-height: 40px;
    text-align: center;
    font-style: normal;
  }
}
</style>
